// @flow

import styled from 'styled-components';

import { HighlightBox } from '../../../../../../commons/atoms';

export const InformationAccordion = styled.div`
  ${HighlightBox} + ${HighlightBox} {
    border-top: none;
  }

  > *:nth-child(n+2) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  > *:nth-last-child(n+2) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
